import React, { useEffect } from 'react';

import Auth from '../../utils/Auth';
import { NPOS_APP } from '../../utils/constants';
import { getApplicationSource } from '../../utils/iframeMessaging';

import initializePKCEFlow from './PKCEFlow';
import RouteValidator from './RouteValidator';

const OktaAuth = () => {
  useEffect(() => {
    if (!Auth.isAuthenticated() && getApplicationSource !== NPOS_APP) initializePKCEFlow();
  }, []);

  return (
    <RouteValidator>
      <main className="ncss-col-sm-12 mt12-sm pt2-sm ta-sm-c">
        <p className="headline-4">You are being authorized.</p>
      </main>
    </RouteValidator>
  );
};

export default OktaAuth;
